import { P2GBadge, P2GGrid } from '@parcel2go/core-ui';
import { useMemo } from 'react';
import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { ToUniqueExtras } from '~/apps/smartsend/lib/helpers/ToUniqueExtras';
import { EditType } from './EditType';
import { P2GLink } from '@parcel2go/core-ui';
import { ProtectionExtraIds } from '../../ExtrasHelper';
import { SettingsCache } from '~/lib/consts/settings-cache';
import BrSplitter from '../../../lib/helpers/BrSplitter';
import { Trans, useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

interface props {
  item: SmartSendItemApiModel;
  edit?: (type: EditType) => void;
}

export default function ItemExtrasSummary(props: props) {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  const limit = 3;
  const extras = useMemo(
    () =>
      props.item.MarketplaceStatus === 'Sold' &&
      ToUniqueExtras(
        t,
        props.item.Extras.filter((x) => !ProtectionExtraIds.includes(x.Id))
      ).sort((a, b) => b.length - a.length),

    [t]
  );

  if (props.item.MarketplaceStatus !== 'Sold' || !SettingsCache.settings.Features.includes('Extras')) {
    return null;
  }

  if (extras?.length > limit) {
    return (
      <P2GGrid item flexShrink={1}>
        <P2GBadge badgeContent={extras.length} colour="primary">
          <P2GLink onClick={() => props.edit('EXTRAS')} variant="body2">
            <Trans t={t} i18nKey="SELECT_EXTRAS_LINK" defaults="Select<br />Extras" />
          </P2GLink>
        </P2GBadge>
      </P2GGrid>
    );
  }

  return (
    <>
      <P2GGrid item flexShrink={1}>
        <P2GLink onClick={() => props.edit('EXTRAS')} variant="body2">
          <Trans t={t} i18nKey="ADD_EXTRAS_LINK" defaults="Add<br />Extras" />
        </P2GLink>
      </P2GGrid>
      {extras.map((e) => (
        <P2GGrid item flexShrink={1} key={e}>
          <P2GLink onClick={() => props.edit('EXTRAS')} variant="body2">
            <BrSplitter label={e} />
          </P2GLink>
        </P2GGrid>
      ))}
    </>
  );
}
